import { Link } from "react-router-dom";
import { CATEGORIES, SALON } from "../../data/salon";
import Blob from "../../art/Blob";
import "./layout.css";

export default function Footer() {
  return (
    <footer className="ftr">
      <Blob tone="#3A322C" className="ftr__blob" aria-hidden="true" />

      <div className="wrap wrap--wide ftr__inner">
        <div className="ftr__brand">
          <span className="ftr__mark">{SALON.name}</span>
          <p className="ftr__tag">
            سالن زیبایی رُز — جایی که نتیجه، از مشاوره شروع می‌شود.
          </p>

          <Link to="/booking" className="btn btn--light">رزرو نوبت</Link>
        </div>

        <nav className="ftr__cols" aria-label="ناوبری پاورقی">
          <div className="ftr__col">
            <span className="eyebrow eyebrow--light">SERVICES</span>
            <ul>
              {CATEGORIES.map((c) => (
                <li key={c.slug}>
                  <Link to={`/services?c=${c.slug}`}>{c.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="ftr__col">
            <span className="eyebrow eyebrow--light">SALON</span>
            <ul>
              <li><Link to="/staff">متخصصین</Link></li>
              <li><Link to="/portfolio">نمونه‌کارها</Link></li>
              <li><Link to="/offers">پیشنهادها</Link></li>
              <li><Link to="/services">همه خدمات</Link></li>
            </ul>
          </div>

          <div className="ftr__col">
            <span className="eyebrow eyebrow--light">HOURS</span>
            <ul>
              {SALON.hours.map((h) => (
                <li key={h.d} className="ftr__hour">
                  <span>{h.d}</span>
                  <span className="ftr__hourVal">{h.h}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="ftr__col">
            <span className="eyebrow eyebrow--light">CONTACT</span>
            <ul>
              <li>{SALON.address}</li>
              <li className="lat">{SALON.phone}</li>
              <li className="lat">{SALON.mobile}</li>
            </ul>
          </div>
        </nav>
      </div>

      <div className="wrap wrap--wide ftr__base">
        <span>© ۱۴۰۴ سالن زیبایی رُز</span>
        <span className="eyebrow eyebrow--light">CRAFTED IN TEHRAN</span>
      </div>
    </footer>
  );
}
